import { forwardRef, useMemo, useState } from 'react';
import Grid, {
    GridExposedMethods,
    GridSettings,
    type OnViewChangedCallback,
} from '~/components/Grid';
import { useReportQuery } from '~/lib/Queries.js';
import type { ReportResponse, ClientReportObject } from '~/lib/Api.types';
import { ReportType, TemplateIndex } from '../../ReportsIndexPage/Report.types';
import useColumnsFromKeys from './useColumnsFromKeys';
import ClientDetails from '~/components/clients/ClientDetails';

type ClientsGridProps = {
    initialSettings?: GridSettings;
    onViewChanged?: OnViewChangedCallback<ClientReportObject>;
    templateSelected?: TemplateIndex;
};
type ClientsReport = ReportResponse<ClientReportObject>;
const ClientsGrid = forwardRef<GridExposedMethods, ClientsGridProps>(
    ({ initialSettings, onViewChanged, templateSelected }, ref) => {
        const {
            data: clientsReport,
            isFetchingNextPage,
            isLoading,
        } = useReportQuery<ClientReportObject>(ReportType.Clients);

        const [selectedClient, setSelectedClient] = useState<{
            id: number;
        } | null>(null);

        const columns = useColumnsFromKeys<ClientsReport>(
            clientsReport,
            ReportType.Clients,
            templateSelected,
            { setSelectedEvent: (client) => setSelectedClient(client ? { id: client.id } : null) },
        );

        return (
            <>
                <ClientDetails
                    client={selectedClient}
                    onClose={() => setSelectedClient(null)}
                    refetch={() => null}
                />
                <Grid<ClientReportObject>
                    isFetchingMore={isFetchingNextPage}
                    ref={ref}
                    columns={columns}
                    rowData={(clientsReport as ClientsReport)?.data}
                    initialSettings={initialSettings}
                    onViewChanged={onViewChanged}
                    isLoading={isLoading}
                />
            </>
        );
    },
);
export default ClientsGrid;

